import {isEmpty} from "@pg-mono/nodash";

import {creditCalculatorAnalytics, CreditCalculatorGTMEvent, CreditCalculatorInstalmentEventAction, CreditCalculatorWorthinessEventAction} from "./credit_gtm";

export const sendCreditEvent = (event: CreditCalculatorGTMEvent) => {
    let data = {};

    if (event === CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR) {
        data = {credit_action: CreditCalculatorInstalmentEventAction.CALL};
    }

    if (event === CreditCalculatorGTMEvent.CREDIT_WORTHINESS_CALCULATOR) {
        data = {credit_action: CreditCalculatorWorthinessEventAction.CALL};
    }

    if (isEmpty(data)) {
        console.error(`wrong event for credit application send`);
        return;
    }

    creditCalculatorAnalytics.gtm.creditCalculatorEvent(event, data);
};
import {isEmpty} from "@pg-mono/nodash";

import {creditCalculatorAnalytics, CreditCalculatorGTMEvent, CreditCalculatorInstalmentEventAction, CreditCalculatorWorthinessEventAction} from "./credit_gtm";

export const sendCreditEvent = (event: CreditCalculatorGTMEvent) => {
    let data = {};

    if (event === CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR) {
        data = {credit_action: CreditCalculatorInstalmentEventAction.CALL};
    }

    if (event === CreditCalculatorGTMEvent.CREDIT_WORTHINESS_CALCULATOR) {
        data = {credit_action: CreditCalculatorWorthinessEventAction.CALL};
    }

    if (isEmpty(data)) {
        console.error(`wrong event for credit application send`);
        return;
    }

    creditCalculatorAnalytics.gtm.creditCalculatorEvent(event, data);
};
